import { render, staticRenderFns } from "./KS_JPShippingmark.vue?vue&type=template&id=56724534&scoped=true&"
import script from "./KS_JPShippingmark.vue?vue&type=script&lang=js&"
export * from "./KS_JPShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./KS_JPShippingmark.vue?vue&type=style&index=0&id=56724534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56724534",
  null
  
)

export default component.exports